import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TanAssigneePickerComponent } from 'src/app/pages/create/shared/assignee-picker/assignee-picker.component';

export interface SequentialReviewPickerHostData {
  targetLangs: string[];
  /** Skill of the review window being extended (assignee_skills key). */
  skillKey?: string;
  sourceLang?: string;
}

/**
 * Fullscreen dialog that only hosts the shared assignee picker.
 *
 * Why a second MatDialog: the picker cannot live inside the sequential-review
 * dialog (its fixed overlay gets contained by the transformed dialog pane) nor
 * in the page (the task panel sits in a stacking context below Material's
 * overlay container, and the tan-* CSS variables the picker needs only exist
 * inside .tan-native wrappers of the create forms). A fullscreen dialog opened
 * on top solves the stacking for free, and the .tan-native wrapper here brings
 * the tokens. ViewEncapsulation.None so the panelClass chrome-stripping styles
 * and the tokens apply (project convention for dialog panel styling).
 */
@Component({
  selector: 'tan-sequential-review-picker-host',
  standalone: true,
  imports: [TanAssigneePickerComponent],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="tan-native">
      <tan-assignee-picker
        [open]="true"
        role="reviewer"
        mode="single"
        [skillKey]="data.skillKey"
        [sourceLang]="data.sourceLang"
        [targetLangs]="data.targetLangs"
        (openChange)="onOpenChange($event)"
        (assign)="onAssign($event)"></tan-assignee-picker>
    </div>
  `,
  styleUrls: ['./sequential-review-picker-host.component.scss'],
})
export class SequentialReviewPickerHostComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SequentialReviewPickerHostData,
    private dialogRef: MatDialogRef<SequentialReviewPickerHostComponent>
  ) {}

  onOpenChange(open: boolean): void {
    if (!open) {
      this.dialogRef.close(null);
    }
  }

  onAssign(event: any): void {
    this.dialogRef.close(event?.person ?? null);
  }
}
